/*
 * @Author: zhangcongcong zhangcongcong@move2newidea.com
 * @Date: 2023-11-01 14:40:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-17 14:04:36
 * @FilePath: /memo-web/src/components/memos/sreen.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import { useEffect, useState, useRef } from 'react'
import { Modal, message, Button, Input } from 'antd'

import './index.scss'
import * as apis from '../../api/networkDisk'
import { StorageModule } from '../../modules/storage';

import useStore from '../../store/useStore'
import { DocumentEditor } from "@onlyoffice/document-editor-react";
import ModelScreen from './modelScreen';
import { content } from 'html2canvas/dist/types/css/property-descriptors/content'

interface Props {
    visible?: any
    onClose?: () => void;
    onRefresh?: () => void;
    onClick?: (i: any) => void;
    saveNode?: (i: any, txt: any,) => void;
    change?: (i: any) => void;
    isEdit?: any
}

const OfficePop = (props: Props) => {
    const { store, dispatch } = useStore();
    const [config, setConfig] = useState<any>();
    let userInfo: any = StorageModule.getUser().user;
    const [fileId, setFileId] = useState<any>(null);
    //编辑状态下，从未有过文稿meta
    const [isNoWordMeta, setIsNoWordMeta] = useState<any>(false);
    const [tagMetas, setTagMetas] = useState<any>();
    const inputRef = useRef<any>()
    const [content, setContent] = useState<any>(store.myEditMemo?.data?.content);


    useEffect(() => {
        console.log('store.myEditMemo?.data', store.myEditMemo?.data,)
        console.log(' store.selectTagMeta', store.selectTagMeta)
        let tagMetas = {}
        if (!isNoWordMeta && fileId && JSON.stringify(store.myEditMemo?.data) != '{}') {
            // setContent(store.myEditMemo?.data.content)
            store.myEditMemo?.data?.tagMetas.map((item: any) => {
                if (item.mimeType == 'application/msword' || item.mimeType == 'application/vnd.ms-excel' || item.mimeType == 'application/vnd.ms-powerpoint') {
                    tagMetas = {
                        ...item,
                        instance: {
                            ...item.instance,
                            fileId: fileId,
                            // content: content
                        }
                    }
                }
            })
            if (JSON.stringify(tagMetas) != '{}') {
                // dispatch({
                //     type: 'SET_MYEDITMEMO',
                //     data: { ...store.myEditMemo, content: store.selectTagMeta.notation + fileId, data: { ...store.myEditMemo.data, tagMetas: [{ ...tagMetas }] } }
                // });
                setIsNoWordMeta(false)
            } else {
                tagMetas = {
                    ...store.selectTagMeta,
                    instance: {
                        ...store.selectTagMeta.instance,
                        fileId: fileId,
                        // content: content
                    }
                }
                // dispatch({
                //     type: 'SET_MYEDITMEMO',
                //     data: { ...store.myEditMemo, content: store.selectTagMeta.notation + fileId, data: { ...store.myEditMemo.data, tagMetas: [{ ...tagMetas }] } }
                // });
                setIsNoWordMeta(true)
            }
            setTagMetas(tagMetas)
        }
    }, [fileId, store.myEditMemo, store.selectTagMeta, content])
    useEffect(() => {
        console.log('office store.myEditMemo', store.myEditMemo,)
        if (JSON.stringify(store.selectTagMeta) != "{}" && store.selectTagMeta) {
            if (store.memoOperation.isAdd) {
                getId()
            } else {
                openFile("Example_Document_Title")
            }
        }
    }, [store.selectTagMeta])
    const getId = async () => {
        try {
            let res: any = await apis.sequenceSerial()
            console.log('sequenceSerial', res.data)
            if (res.ok) {
                openFile("Example_Document_Title", res.data[0])
            }
        } catch (e) { }
    }
    const key = async (name: any, id?: any) => {
        console.log("token",)
        console.log('office确认', store.memoOperation.isAdd)
        console.log('office_store.myEditMemo', store.myEditMemo)
        console.log('office_store.memoNode', store.memoNode,)
        console.log('SET_SELECTTAGMETA', store.selectTagMeta,)
        let _id: any = ""
        if (store.memoOperation.isAdd) {
            _id = id
            dispatch({
                type: 'SET_MYEDITMEMO',
                data: { ...store.myEditMemo, data: { ...store.myEditMemo.data, id: id } }
            });
        } else {
            _id = store.memoNode.id
        }
        let res: any = await apis.getOfficeKey(_id, store.selectTagMeta.notation)
        console.log('res', res,)
        const str = res.data.key;
        const index = str.indexOf("NN");

        setFileId(res.data.fileId)
        return res.data
        // return fetch(`${process.env.REACT_APP_SCP}/api/only/office/file/${name}/key`)
        //     .then(resp => resp.text());
    };

    const openFile = async (_fileName: any, id?: any) => {
        let suffix: any = (store.selectTagMeta.name == '文档文稿') ? 'docx' : (store.selectTagMeta.name == '表格文稿') ? "xlsx" : "ppt"
        let fileName = _fileName + '.' + suffix
        const DocumentType = new Map();
        const WordTypes = ['doc', 'docm', 'docx', 'docxf', 'dot', 'dotm', 'dotx', 'epub', 'fb2', 'fodt', 'htm', 'html', 'mht', 'mhtml', 'odt', 'oform', 'ott', 'rtf', 'stw', 'sxw', 'txt', 'wps', 'wpt'];
        const CellTypes = ['csv', 'et', 'ett', 'fods', 'ods', 'ots', 'sxc', 'xls', 'xlsb', 'xlsm', 'xlsx', 'xlt', 'xltm', 'xltx'];
        const SlideTypes = ['dps', 'dpt', 'fodp', 'odp', 'otp', 'pot', 'potm', 'potx', 'pps', 'ppsm', 'ppsx', 'ppt', 'pptm', 'pptx', 'sxi'];
        const PdfTypes = ['djvu', 'oxps', 'pdf', 'xps'];
        WordTypes.forEach(type => DocumentType.set(type, 'word'))
        CellTypes.forEach(type => DocumentType.set(type, 'cell'))
        SlideTypes.forEach(type => DocumentType.set(type, 'slide'))
        PdfTypes.forEach(type => DocumentType.set(type, 'pdf'))
        const USERNAME = '_onlyoffice_demo_username';
        const docKey = await key(fileName, id);
        const fileType = fileName.substr(fileName.indexOf('.') + 1);
        const documentType = DocumentType.get(fileType)
        console.log('documentType', documentType)
        // const documentType = 'word'
        const username = localStorage.getItem(USERNAME);
        const fileUrl = `${process.env.REACT_APP_SCP}/api/rubik/file/${docKey.fileId}/raw?token=${StorageModule.getUser().token}`
        let config: any = {
            "type": "desktop",
            "documentType": documentType,
            "height": "100%",
            "width": "100%",
            "locale": "zh-CN",
            "document": {
                "fileType": fileType,
                "key": docKey.key,
                "title": fileName,
                "url": fileUrl,
                "referenceData": {
                    "fileKey": fileName,
                    "instanceId": 'onlyoffice-demo',
                    "key": docKey.key
                },
                "permissions": {
                    edit: props.isEdit ? false : true
                }
            },
            "editorConfig": {
                "lang": "zh",
                "callbackUrl": `${process.env.REACT_APP_SCP}/api/only/office/save`,
                "user": {
                    "group": "Group1",
                    "id": userInfo.id,
                    "name": userInfo.username
                }
            },
            token: ""
        }

        // const resp = await fetch(`${process.env.REACT_APP_SCP}/api/only/office/token`, {
        //     method: 'POST',
        //     headers: {
        //         "Content-Type": "application/json",
        //         Authorization: projectToken
        //     },
        //     body: JSON.stringify(config)
        // })
        const token = await getOfficeToken(config);
        config.token = token;
        console.log('kkkk', JSON.stringify(config))
        setConfig(config)
        // docEditor = new DocsAPI.DocEditor("editor", config);
    }
    const getOfficeToken = async (params: any) => {
        let res: any = await apis.getOfficeToken(params)
        return res.data
    }
    const onDocumentReady = (fileName: any) => {
        console.log("Document is loaded", fileName);
    };

    const onLoadComponentError = (errorCode: any, errorDescription: any) => {
        console.log('onLoadComponentError', errorCode)
        switch (errorCode) {
            case -1: // Unknown error loading component
                console.log(errorDescription);
                break;

            case -2: // Error load DocsAPI from http://documentserver/
                console.log(errorDescription);
                break;

            case -3: // DocsAPI is not defined
                console.log(errorDescription);
                break;
        }
    };
    /**
    * 新建/修改Office内容
    * @returns 
    */
    const render = (
        <div className='docxEditorBox HScreen'>
            <div className='mb-10' data-flex='main:justify cross:center'>
                <ModelScreen showSelect={store.memoOperation.isAdd} name={
                    <div>{store.selectTagMeta?.name}</div>
                } />

                {/* {(store.memoOperation.isAdd || (!store.memoOperation.isAdd && isNoWordMeta)) && */}
                <Button className='btn_dark btn mr-30' key='btn' onClick={() => {
                    if (!content || content == '') {
                        message.warn('请输入文件名')
                        return
                    }
                    console.log('office确认', store.myEditMemo)
                    dispatch({
                        type: 'SET_MYEDITMEMO',
                        data: { ...store.myEditMemo, content: content, data: { ...store.myEditMemo.data, tagMetas: [{ ...tagMetas }], content: content } }
                    });
                    props.change && props.change('state.txtStr')
                    // state.txtStr = props.txt
                    // setState(state)
                    console.log('state.txtStr', store.selectTagMeta?.mimeType)
                    setTimeout(() => {
                        props.saveNode && props.saveNode('document', content)
                        props.onClose && props.onClose()
                    }, 500);
                }}>确认</Button>
                {/* } */}
            </div>
            <div className='mt-10'>
                <Input placeholder="请输入文件名" className=' mb-10' ref={inputRef} value={content} onChange={(e) => {
                    setContent(e.target.value)
                }} onPressEnter={() => { }} />
                <DocumentEditor
                    id="docxEditor"
                    documentServerUrl="https://onlyoffice.move2newidea.com"
                    config={config}
                    events_onDocumentReady={onDocumentReady}
                    onLoadComponentError={onLoadComponentError}
                />
            </div>
        </div>
    )
    return render
}

export default OfficePop
